import axios from 'axios'

// Get API base URL from environment or use default
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'

console.log('🌐 API Base URL:', API_BASE_URL)

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 60000, // 60 second timeout to handle Render cold starts
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // Log actual request URL on failure - MANDATORY
    console.log('📤 API Request:', config.method?.toUpperCase(), config.url)
    return config
  },
  (error) => {
    console.error('❌ Request Error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.config.method?.toUpperCase(), response.config.url, response.status)
    return response
  },
  (error) => {
    // Log actual request URL on failure
    console.error('❌ API Error:', error.config?.method?.toUpperCase(), error.config?.url)
    console.error('❌ Error Details:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      timeout: error.code === 'ECONNABORTED'
    })

    // Check if this is an auth endpoint
    const isAuthEndpoint = error.config?.url?.includes('/auth/login') ||
      error.config?.url?.includes('/auth/register') ||
      error.config?.url?.includes('/auth/send-otp') ||
      error.config?.url?.includes('/auth/verify-otp') ||
      error.config?.url?.includes('/auth/reset-password')

    // Differentiate between error types
    if (error.code === 'ECONNABORTED') {
      console.error('⏰ Request timeout exceeded')
      error.userMessage = 'Request timeout - please check your connection'
    } else if (error.response) {
      // Server responded with error status
      const status = error.response.status
      const message = error.response.data?.message

      if (status >= 400 && status < 500) {
        console.error('🚫 Client Error (4xx):', status)
        // Use the backend's error message if available
        error.userMessage = message || error.response.data?.error || 'Request failed'
      } else if (status >= 500) {
        console.error('💥 Server Error (5xx):', status)
        error.userMessage = message || 'Server error - please try again later'
      }
    } else if (error.request) {
      // Network error - no response received
      console.error('🌐 Network Error - Backend unreachable')
      error.userMessage = 'Cannot reach server - please check your connection'
    } else {
      console.error('❓ Unknown Error:', error.message)
      error.userMessage = 'An unexpected error occurred'
    }

    // Handle authentication errors
    // Only redirect if it's NOT an auth endpoint and token is expired
    if (error.response?.status === 401 && !isAuthEndpoint) {
      console.log('🔐 Token expired - redirecting to login')
      localStorage.removeItem('token')

      // Only redirect if we're not already on the login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }

    // For auth endpoints, never redirect, just pass the error through
    if (isAuthEndpoint) {
      console.log('🔓 Auth endpoint error - passing through to component')
    }

    return Promise.reject(error)
  }
)

export default api